import { render, staticRenderFns } from "./TextAreaBox.vue?vue&type=template&id=2eada01e&scoped=true&"
import script from "./TextAreaBox.vue?vue&type=script&lang=ts&"
export * from "./TextAreaBox.vue?vue&type=script&lang=ts&"
import style0 from "./TextAreaBox.vue?vue&type=style&index=0&id=2eada01e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eada01e",
  null
  
)

export default component.exports